import { NdcSegments as NdcSegmentsType } from '../../types/code.types';

interface NdcSegmentsProps {
  segments: NdcSegmentsType;
}

const NdcSegments = ({ segments }: NdcSegmentsProps) => {
  const hasCoreSegments = segments.labelerCode !== null && segments.productCode !== null;
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-2xl font-bold mb-4">🔢 NDC Segment Breakdown</h2>
      {hasCoreSegments ? (
        <div className="p-3 bg-gray-50 rounded-lg">
          <p className="text-gray-800">
            Labeler <span className="font-mono font-bold text-primary-700">{segments.labelerCode}</span>
            <span className="text-gray-400 mx-2">—</span>
            Product <span className="font-mono font-bold text-primary-700">{segments.productCode}</span>
            <span className="text-gray-400 mx-2">—</span>
            Package <span className="font-mono font-bold text-primary-700">{segments.hasPackageSegment ? segments.packageCode : '(not available)'}</span>
          </p>
          {segments.hasPackageSegment && segments.normalized11Digit && (
            <p className="text-sm text-gray-500 mt-2">11-digit billing format: <span className="font-mono">{segments.normalized11Digit}</span></p>
          )}
          {segments.note && <p className="text-sm text-gray-500 mt-2">{segments.note}</p>}
        </div>
      ) : (
        segments.note && <p className="text-gray-600 text-sm">{segments.note}</p>
      )}
    </div>
  );
};

export default NdcSegments;
